import AntIcon from "@/components/icons/AntIcon";
import { Button } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHasPermissions } from "../../auth/hooks";
import { Contract, ContractIncrement } from "../types";
import { contractPermissionsByContractType } from "../utils";
import { ContractIncrementModalForm } from "./forms/ContractIncrementModalForm";
import { ContractIncrementsTable } from "./tables/ContractIncrementsTable";

type Props = {
  contract: Contract;
};

export const ContractIncrements = ({ contract }: Props) => {
  const { t } = useTranslation();

  const [isOpenContractIncrementModal, setIsOpenContractIncrementModal] = useState(false);
  const [contractIncrementUpdate, setContractIncrementUpdate] = useState<ContractIncrement>();

  const hasPrivilegedChangesOnVerifiedPermission = useHasPermissions(
    contractPermissionsByContractType[contract.type].privilegedChangesOnVerified,
  );

  const handleContractIncrementUpdate = (contractIncrement: ContractIncrement) => {
    setIsOpenContractIncrementModal(true);
    setContractIncrementUpdate(contractIncrement);
  };

  const handleCancelContractIncrementModal = () => {
    setIsOpenContractIncrementModal(false);
    setContractIncrementUpdate(undefined);
  };

  return (
    <>
      <ContractIncrementsTable
        contractId={contract.id}
        onUpdate={handleContractIncrementUpdate}
        contractType={contract.type}
      />

      {hasPrivilegedChangesOnVerifiedPermission && (
        <Button
          className="margin-top-medium"
          type="primary"
          icon={<AntIcon type="plus" />}
          onClick={() => setIsOpenContractIncrementModal(true)}
        >
          {t("contract.actions.addIncrement")}
        </Button>
      )}

      <ContractIncrementModalForm
        contract={contract}
        increment={contractIncrementUpdate}
        isOpen={isOpenContractIncrementModal}
        onCancel={handleCancelContractIncrementModal}
      />
    </>
  );
};
